import {UseFileUpload, useFileUpload} from '../../firebase/hooks/useFileUpload';

const UsersDirectory = 'users';

export function useUserFileUpload(userId: string, path: string, ...segments: string[]): UseFileUpload {
  return useFileUpload(UsersDirectory, userId, path, ...segments);
}
